import React from "react";
import { useState } from "react";
import { Table, TableHead, TableBody, TableRow, TableCell, TableContainer, Avatar, Box, Typography } from "@mui/material";
import styles from "./style";
import CustomPagination from "../../../../components/CustomPagination";
import DeleteOutlineIcon from "@mui/icons-material/DeleteOutline";
import { ReactComponent as Edit } from "../../../../assets/images/edit.svg";
import Modal from "../../../../components/Modal";
import { useNavigate } from "react-router-dom";
import { formatDate } from "../../../../utils/DateFormat";

const LeaveManagementList = ({ data, page, setPage, total, DeleteCommission, setDeleteOpen, setOpen, deleteOpen, handleEdit }) => {
  const [rowsPerPage, setRowsPerPage] = useState(10);
  const [value, setValue] = useState();
  const navigate = useNavigate()

  const deleteData = (item) => {
    setValue(item);
  }

  const handleNavigate = (item) => {
    navigate("/dashboard/viewCommission", { state: { item } })
  }


  return (
    <>


      <TableContainer>
        <Table>
          <TableHead>
            <TableRow>
              <TableCell sx={styles.TableHead}>Name</TableCell>
              <TableCell sx={styles.TableHead}>Rate</TableCell>
              <TableCell sx={styles.TableHead}>Rate Type</TableCell>
              <TableCell sx={styles.TableHead}>Commission From</TableCell>
              <TableCell sx={styles.TableHead}>Commission To</TableCell>
              <TableCell sx={styles.TableHead}>Status</TableCell>
              <TableCell sx={styles.TableHead}>Action</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {data.length === 0 ? (
              <TableRow>
                <TableCell colSpan={8} align="center">
                  <Typography variant="h6">No data</Typography>
                </TableCell>
              </TableRow>
            ) : (
              data.map((item, index) => (

                <TableRow key={index}>

                  <TableCell sx={styles.tableAvtardata} onClick={() => handleNavigate(item)}>
                    <Avatar src={item.employeeDetails?.personalInfo?.image} sx={{ mr: "8px" }} /><Box >
                      <Typography sx={styles.name}>{item?.employeeDetails?.personalInfo?.firstName} {item?.employeeDetails?.personalInfo?.surName}</Typography>
                      <Typography sx={styles.mail}>{item?.employeeDetails?.personalInfo?.email}</Typography>
                    </Box>       </TableCell>
                  <TableCell sx={styles.tabledata}>{item?.rate}</TableCell>
                  <TableCell sx={styles.tabledata}>{item?.rateType}</TableCell>
                  <TableCell sx={styles.tabledata}>{formatDate(item?.start)}</TableCell>
                  <TableCell sx={styles.tabledata}>{formatDate(item?.end)}</TableCell>
                  <TableCell sx={{ borderBottom: 0 }}><Box sx={{
                    border: `1px solid ${item.status === "Approved" ? "#28AA4A" :
                      item.status === "Rejected" ? "#FF0000" :
                        item.status === "Pending" ? "#F4B63F" :
                          item.status === "Weekend" ? "#00ABF4" :
                            "black"
                      }`,
                    borderRadius: "30px", display: "flex", justifyContent: "center", alignItems: "center", py: "5px", px: "14px", fontSize: "12px", width: "fit-content", textTransform: "capitalize",
                    color: `${item.status === "Approved" ? "#28AA4A" :
                      item.status === "Rejected" ? "red" :
                        item.status === "Pending" ? "#F4B63F" :
                          item.status === "Weekend" ? "#00ABF4" :
                            "black"
                      }`

                  }}>{item.status}</Box></TableCell>
                  {/* <TableCell sx={styles.tabledata}>{item?.noOfDays}</TableCell> */}
                  <TableCell sx={styles.tableData} >
                    <Box sx={styles.tableActiondata}>

                      {/* <Link  > */}

                      <Edit onClick={() => { setOpen(true); handleEdit("edit", item) }} />
                      {/* </Link> */}
                      {/* {permission?.isEdit && */}
                      <DeleteOutlineIcon sx={styles.deleteIcon} onClick={() => {
                        deleteData(item?._id), setDeleteOpen(true);
                      }}
                      />
                      {/* } */}
                    </Box>
                  </TableCell>
                </TableRow>
              )))}
          </TableBody>

        </Table>
        {data &&

          <CustomPagination
            pageCount={total}
            page={page}
            setPage={setPage}
            rowsPerPage={rowsPerPage}
            setRowsPerPage={setRowsPerPage}
            totalItems={data.length}
          />}

      </TableContainer>

      <Modal open={deleteOpen} setOpen={setDeleteOpen} deletetText={"Delete"} cancelText={"Cancel"} title={"Delete Employee"} handleDelete={() => { DeleteCommission(value); setDeleteOpen(false) }}>
        <Box>
          <Typography>Are you sure you want to Delete?</Typography>

        </Box>
      </Modal>

    </>
  );
};
export default LeaveManagementList;
